import gql from 'graphql-tag';
import { PricedOptionGroupFields, ProductBrandFields, ProductVariantFields } from '../product.queries';

/**
 * Keycode Validation Query
 */
export const VALIDATE_KEYCODE = gql`
	query ValidateKeyCode($keyCode: String!, $variantId: Int!) {
		validateKeyCode(keyCode: $keyCode, variantId: $variantId) {
			code
		}
	}
`;

export const SELECTED_PRICED_OPTION = gql`
	${ProductVariantFields}
	${PricedOptionGroupFields}
	${ProductBrandFields}
	query SelectedPricedOption(
		$id: Int!
		$variantId: Int
		$productStatus: [ProductStatusEnum!] = [stock, discontinued]
		$regionId: String
	) {
		productFamily(id: $id, variantId: $variantId, regionId: $regionId) {
			... on ProductFamily {
				title
				brandInfo {
					...ProductBrandFields
				}
				variants(status: $productStatus) {
					...ProductVariantFields
				}
				productOptionGroups {
					...PricedOptionGroupFields
				}
			}
		}
	}
`;
